<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Instrument Environmental Conditions '{{inner_Device.title}}'</h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-6">

          <button *ngIf="!Procssing" (click)="Submit()" type="button" class="btn btn-success" style="margin-right: 5px;"><i
              class="fa  fa-plus-circle"></i> Save </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>Delta</th>
              <th>Min Range</th>
              <th>Max Range</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataentityEnvironment_DataList">
              <td>{{DataentityEnvironment_DataList.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>
                <input type="number" style="width: 70px;" name="detal_{{DataentityEnvironment_DataList.indexOf(item)}}"
                  [(ngModel)]="item.detal">
              </td>
              <td>
                <input type="number" style="width: 70px;" name="min_range_{{DataentityEnvironment_DataList.indexOf(item)}}"
                  [(ngModel)]="item.min_range">
              </td>
              <td>
                <input type="number" style="width: 70px;" name="max_rage_{{DataentityEnvironment_DataList.indexOf(item)}}"
                  [(ngModel)]="item.max_rage">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
